import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import 'moment-timezone';
import { Location } from '@angular/common';
import { SubSink } from 'subsink';

import { LoginComponent } from '../../login/login.component';
import { PromovideoComponent } from '../../promovideo/promovideo.component';
import { StorageService } from '../../shared/services/storage.service';
import { AppStorage, StreamType } from '../../providers/enum';
import { LoginService } from '../../login/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MainHomePageService } from './services/main-home-page.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { HowtowatchontvComponent } from 'src/app/howtowatchontv/howtowatchontv.component';
import { SponsorlinksComponent } from 'src/app/sponsorlinks/sponsorlinks.component';
import { VimeoplayerComponent } from 'src/app/vimeoplayer/vimeoplayer.component';
import { SuccessMessageComponent } from 'src/app/success-message/success-message.component';
import { FailMessageComponent } from 'src/app/fail-message/fail-message.component';


@Component({
  selector: 'app-main-home-page',
  templateUrl: './main-home-page.component.html',
  styleUrls: ['./main-home-page.component.scss']
})
export class MainHomePageComponent implements OnInit {

  //#region variables

  public handler: any = null;
  public errorMessage: string;
  public paymentSuccess = false;
  public modalRef: BsModalRef;
  public userData: any;
  public streamDetails: any;
  public streamDescFull: any;
  public textBelowPoster: any;
  public streamDetailsFull: any;
  public isUserLogin: boolean = false;
  public isWatchWithAccessCodeClick: boolean = false;
  public isTimeLeftLessOrEqual15: boolean;
  public isLiveEventBuyed: string;
  public viewEventFlag: boolean;
  public DomainName: string;
  public currentTimeZone: string;
  public isPaymentDisable: boolean = false;
  public isWatchEventDisable: boolean = false;
  public showLoading: boolean = true;
  public channelButtonActive = false;
  public extraButtonActive = false;
  public timerInterval: any;
  public contentBackground: string;
  public domain: string;
  public isURLSuccess: boolean = false;
  public isURLCancel: boolean = false;
  public timeDiff;
  public loginButtonActive = true;
  public paymentButtonActive = true;
  public watcheventButtonActive = true;
  public resendButtonActive = true;
  public eventCounterShow = true;
  public myAngularxQrCode: string = null;
  public eventFooterLink = true;
  public textAboveButtonActive = true;
  public streamType: StreamType;
  public isEventStart: boolean = false;
  public stream_addthis_id: string;
  public contentBackgroundStyle: string;
  public promoLinkActive: boolean;
  public iosAppAvailable: boolean;
  public androidAppAvailable: boolean;
  public streamCorrect: boolean;
  public clientDetails1: any;
  public clientDetailsLocal: any;
  public appDetailsHP: any;
  public appDesignHP: any;
  public swigitsHP: any;
  public appBundlesHP: any;
  private subs = new SubSink();
  public siteDomainHP: string;
  public isClientPage: boolean = true;
  public bundPurchased: boolean = false;
  public bundPurchasedOn: string;
  public stripeAPIPubKeyLS: string;
  public stripeAPITokenKeyLS: string;
  public paymentModeV: string;
  public bundlePrice: any;
  public characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  public appStrData: any;
  public urlStripe: any;
  public payCode: any;
  public payMessage: any;
  //#endregion

  
  //#region life-cycle methods
  public loadStyle(url: string) {
    const body = <HTMLDivElement> document.body;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = 'style.css';
    body.appendChild(link);
  }

  public loadScript(url: string) {
    
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
   // alert("hello");
  }

  constructor(private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private storageService: StorageService,
    private loginService: LoginService,
    private location: Location,
    private mainHomePageService: MainHomePageService,) {

    let clientDetails = this.storageService.get(AppStorage.clientDetails, true);
    this.clientDetailsLocal = JSON.parse(clientDetails);
    //console.log('this.clientDetailsLocal: ', this.clientDetailsLocal);
    this.appDetailsHP = this.clientDetailsLocal.data.appDetails;
    this.appDesignHP = this.clientDetailsLocal.data.appDesigns;
    this.swigitsHP = this.clientDetailsLocal.data.swigits;
    let SwigitHPVar = this.clientDetailsLocal.data.swigits;
    this.appBundlesHP = this.clientDetailsLocal.data.appBundles;
    this.isClientPage = this.clientDetailsLocal.ClientPageVar;
    this.bundPurchased = this.clientDetailsLocal.data.bundle_purchased;
    this.bundPurchasedOn = this.clientDetailsLocal.data.bundle_purchased_on;

      this.streamCorrect = true;
      this.showLoading = false;
    this.loadScript('../../../assets/js/popper.min.js');
    this.loadScript('../../../assets/js/bootstrap.min.js');
    
    this.loadScript('../../../assets/js/slick.min.js');
    this.loadScript('../../../assets/js/slick-animation.min.js');
    this.loadScript('../../../assets/js/jquery.magnific-popup.min.js');
   // this.loadScript('../../assets/js/swiper.min.js');
   // this.loadScript('../../assets/js/swiper-custom.js');
    this.loadScript('../../../assets/js/bootstrap-datepicker.min.js');
    this.loadScript('../../../assets/js/sidebar.js');

    Array.from(SwigitHPVar, child => {
      //   console.log("ddd=",child)
    });

   // console.log("ookkkkkk");
    

    this.siteDomainHP = this.storageService.get(AppStorage.siteDomain, true);

    //This code for Live 
    let apptitlel = this.route.snapshot.params.url;
    //console.log('this.route.snapshot.params.url: ', this.route.snapshot.params.url);
    if (apptitlel === 'success') {
      this.isURLSuccess = true;
      this.isURLCancel = false;
    } else if (apptitlel === 'cancel') {
      this.isURLSuccess = false;
      this.isURLCancel = true;
    }


    
    this.loadScript('../../../assets/js/owl.carousel.min.js');
    this.loadScript('../../../assets/js/main.js');

    // This code for localhost
    this.route.queryParams.subscribe(params => {
      // console.log("params=", params);
      if (params && params.url) {
        if (apptitlel === 'success') {
          this.isURLSuccess = true;
          this.isURLCancel = false;
        } else if (apptitlel === 'cancel') {
          this.isURLSuccess = false;
          this.isURLCancel = true;
        }
      }
    }, (error: any) => {
      // console.log('error: ', error);
    });

    this.urlStripe = "";
    this.route.queryParams.subscribe(params => {
     //  console.log("params=", params);
      
      if (params && params.url) {
        this.urlStripe = params.url;
        this.payCode = params.payCode;
        
      }
      this.payMessage = params.md;
    }, (error: any) => {
     //  console.log('error: ', error);
    });

    if(this.payMessage == "1")
    {
      this.modalRef = this.modalService.show(
        SuccessMessageComponent,
        Object.assign({ ignoreBackdropClick: true }, { class: 'gray modal-lg' })
      );
      
    }

   
    let appStrDt = this.storageService.get(AppStorage.appBundleStripeData, true);
    let finalAmt = "";
    let StreamG ="";
    let appCID = "";
    let verifyPayCode = "";
    let bundleId = "";
    let stripeKey = "";

    if(appStrDt)
    {
      let appStrDtArr = appStrDt.split(',');
      //console.log("spliaa=", appStrDtArr);

      for (let k=0; k<appStrDtArr.length; k++) { 
        if(appStrDtArr[k] == "unit_amount")
        {
          finalAmt = appStrDtArr[k+1];
        }
        if(appStrDtArr[k] == "stripe_key")
        {
          stripeKey = appStrDtArr[k+1];
        }
        if(appStrDtArr[k] == "bundleId")
        {
          bundleId = appStrDtArr[k+1];
        }
        if(appStrDtArr[k] == "appCId")
        {
          appCID = appStrDtArr[k+1];
        }
        if(appStrDtArr[k] == "payCodeVerify")
        {
          verifyPayCode = appStrDtArr[k+1];
        }
      }
    }

    let data = this.storageService.get(AppStorage.data, true);
    this.userData = JSON.parse(data);

    if (this.userData) {
      this.isUserLogin = true;
    }

    //console.log(this.urlStripe+"inside"+verifyPayCode+"-"+this.payCode);
    if(this.urlStripe == "success" && verifyPayCode == this.payCode)
    {
      //alert("dsf");
        let serverURL = "";
     //console.log("inside");

     this.bundlePurchased(finalAmt, "success", bundleId, appCID, stripeKey);
        
    }
    if(this.urlStripe == "cancel")
    {
      this.modalRef = this.modalService.show(
        FailMessageComponent,
        Object.assign({ ignoreBackdropClick: true }, { class: 'gray modal-lg' })
      );
    }
  }

  ngOnInit(): void {

    
    //console.log("main page  data", this.userData);

    this.paymentModeV = this.clientDetailsLocal.data.appDetails.app_payment_mode;

    if (this.paymentModeV === 'L') {
      this.stripeAPIPubKeyLS = this.clientDetailsLocal.data.appDetails.app_stripe_API_pubkey_live;
      this.stripeAPITokenKeyLS = this.clientDetailsLocal.data.appDetails.app_stripe_API_token_live;
    }
    else if (this.paymentModeV === 'T') {
      this.stripeAPIPubKeyLS = this.clientDetailsLocal.data.appDetails.app_stripe_API_pubkey_test;
      this.stripeAPITokenKeyLS = this.clientDetailsLocal.data.appDetails.app_stripe_API_token_test;
    }

    //console.log("sss=", this.swigitsHP.streams);
    //console.log("history state=", history.length);
  }

  //#endregion

  //#region private methods

  private openLoginModal(): void {
    this.modalRef = this.modalService.show(
      LoginComponent,
      Object.assign({ ignoreBackdropClick: true }, { class: 'gray modal-md' })
    );
  }

  public openSwigitLink(urltoopen: string ): void {
    
    this.storageService.set(AppStorage.historyBundle, 1, true);
    //alert(urltopen);
    window.open(urltoopen, "_blank");

  }

  public watchPromo(promoid: string): void {
    let promourl = "";

    switch(promoid)
    {
      case "1":
          promourl = "https://vimeo.com/781209507/3b16c1a897";
          break;
      case "2":
          promourl = "https://vimeo.com/781267079/3508dde750";
          break;
      case "3":
        promourl = "https://vimeo.com/781227557/45d5743cf5";
        break;
      case "4":
        promourl = "https://vimeo.com/781145945/aff531438f";
        break;
      case "5":
        promourl = "https://vimeo.com/781236984/3aa43be4f1";
        break;

    }

    let initialState = { url: promourl };
    this.modalRef = this.modalService.show(
      VimeoplayerComponent,
      Object.assign({ ignoreBackdropClick: true }, { class: 'gray fullHeight modal-lg', initialState })
    );

  }

  //#endregion

  //#region public methods

  public onPromoBtnClick(streamURL: any): void {
    let initialState = { url: streamURL };
    this.modalRef = this.modalService.show(
      PromovideoComponent,
      Object.assign({ ignoreBackdropClick: true }, { class: 'gray fullHeight modal-lg', initialState })
    );
  }

  public onHowtowatchonTVClick(): void {
    this.modalRef = this.modalService.show(
      HowtowatchontvComponent,
      Object.assign({ ignoreBackdropClick: true }, { class: 'gray  modal-md' })
    );
  }

  public onDealsClick(): void {
    this.modalRef = this.modalService.show(
      SponsorlinksComponent,
      Object.assign({ ignoreBackdropClick: true }, { class: 'gray  modal-lg' })
    );
  }

  public onImageClick() {
    //console.log('das');
    this.router.navigate([`bundle`]);
  }

  public finalpay(price) {
    if (this.userData && this.userData.userCode) {
      this.pay(price);
    } else {
      this.openLoginModal();
    }
  }

  public pay(price) {

    let stripeTokenkey = "";
    let stripeProdId = "";

    if(this.appBundlesHP.bundle_payment_mode == 'T')
    {
      stripeTokenkey = this.appBundlesHP.stripe_API_token_test;
      stripeProdId = this.appBundlesHP.bundle_product_id_test;
    }
    else
    {
      stripeTokenkey = this.appBundlesHP.stripe_API_token_live;
      stripeProdId = this.appBundlesHP.bundle_product_id_live;
    }

    let serverURL = "";
    let bpassURLSucc = "";
    let bpassURLCanc = "";
    var randStr2 = this.generateString(15);

    if(this.appBundlesHP.local_server_flag == 'Y')
    {
      serverURL = this.appBundlesHP.bundle_local_server_url;
      bpassURLSucc = serverURL + '&url=success&payCode='+randStr2;
      bpassURLCanc = serverURL + '&url=cancel';
    }
    else
    {
     // console.log("liveurl=", this.appBundlesHP.bundle_live_server_url);
      serverURL = this.appBundlesHP.bundle_live_server_url;
      bpassURLSucc = serverURL + '&url=success&payCode='+randStr2;
      bpassURLCanc = serverURL + '&url=cancel';
     // console.log("succliveurl=", bpassURLSucc);
    }

   
    
    let bundleAmount = (this.appBundlesHP.bundle_price * 100).toString();
    var formDataG = new FormData();
    formDataG.append('stripe_key', stripeTokenkey);
    formDataG.append('payment_method_types', 'card');
    formDataG.append('product', stripeProdId);
    formDataG.append('unit_amount', bundleAmount);
    formDataG.append('currency', 'usd');
    formDataG.append('success_url', bpassURLSucc);
    formDataG.append('cancel_url', bpassURLCanc);
    formDataG.append('connect_accountID', this.appBundlesHP.connect_destination_acct_id);
    formDataG.append('connect_amount', this.appBundlesHP.connect_charge_amount);


    this.subs.sink = this.mainHomePageService.purchaseBundleByUser(formDataG).subscribe(
      (response: any) => {
       // console.log('response email: ', response);
        if (response.url) {

         
            var formDataObj = [
              ['stripe_key', stripeTokenkey],
              ['payment_method_types', 'card'],
              ['product', stripeProdId],
              ['unit_amount', bundleAmount],
              ['bundleId', this.appBundlesHP.swigit_bundleId_PK],
              ['appCId', this.appBundlesHP.bundle_appcode_FK],
              ['currency', 'usd'],
              ['useremail', this.userData.email],
              ['payCodeVerify', randStr2]
            ];
            
            //alphas = ["1", "2", "3", "4"];
            this.storageService.set(AppStorage.appBundleStripeData, formDataObj, true);
            window.open(response.url, "_self");
        }
        // if (response.status === 0) {
        //   this.errorMessage =
        //     "Oops something went wrong please try again later.";
        // } else {
        //   this.errorMessage = response.msg;
        // }
        this.showLoading = false;
      },
      (error) => {
        //console.log('error: ', error);
        this.errorMessage = "oops something went wrong please try again later.";
        this.showLoading = false;
      }
    );
  }

  //#endregion
  public generateString(length) {
    let result = '';
    const charactersLength = this.characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += this.characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  public openLinkAll(urltopen) {

    window.open(urltopen, "_blank");

  }
  
  private bundlePurchased(amount, payResult, bId, aID, stripeKey) {
   
    var formDataG = new FormData();
    formDataG.append('appId', aID);
    formDataG.append('bundleid', bId);
    formDataG.append('postAction', "buyBundleTicket");
    formDataG.append('userCode', this.userData.userCode);
    formDataG.append('amount', amount);
    formDataG.append('buyInformation', payResult);
    formDataG.append('stripeKeyVal', stripeKey);
    var errMsg = "";
   // console.log('formG=', formDataG);
    this.subs.sink = this.mainHomePageService.bundleCodeGen(formDataG)
      .subscribe(
        (response: any) => {
         // console.log('responseqqqq: ', response);
          if (response.status) {
            errMsg = response.msg;
            

         /*   this.modalRef = this.modalService.show(
              SuccessMessageComponent,
              Object.assign({ ignoreBackdropClick: true }, { class: 'gray modal-lg' })
            );
           */ 
          let serverURLn ="";
            if(this.appBundlesHP.local_server_flag == 'Y')
        {
          serverURLn = this.appBundlesHP.bundle_local_server_url;
        
        }
        else
        {
          
          serverURLn = this.appBundlesHP.bundle_live_server_url;
        }  
      
      let urlopen = serverURLn + "&md=1";
      window.open(urlopen, "_self");
      //location.reload();
            
          } else {
            errMsg = response.msg;
           /*

            this.modalRef = this.modalService.show(
              FailMessageComponent,
              Object.assign({ ignoreBackdropClick: true }, { class: 'gray modal-lg' })
            );
            */
          }
          localStorage.removeItem(AppStorage.appBundleStripeData);
        },
        (error) => {

          /*
          this.modalRef = this.modalService.show(
            FailMessageComponent,
            Object.assign({ ignoreBackdropClick: true }, { class: 'gray modal-lg' })
          );
          */
          localStorage.removeItem(AppStorage.appBundleStripeData);
        }
      );
      
  }


}

